import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[y42SideDetailView]' })
export class SideDetailViewDirective {
  constructor(readonly templateRef: TemplateRef<unknown>) {}
}
